import ColorFactory from "./ColorFactory";
import webase from "../app/model";
import BackgroundFactory from "./BackgroundFactory";

export default class ButtonStyleFactory {

    constructor() {
        this.colorFactory = new ColorFactory()
        this.backgroundFactory = new BackgroundFactory()
    }

    generateSameColorButtons(color) {
        let buttons = {}
        buttons.primary = this.colorFactory.isBlackOrWhite(color) ? this.generateBlackButton() : this.generateContrastingButtons(color)
        buttons.secondary = this.defaultSecondaryButton()
        return buttons
    }

    generateAccentColorButton(color) {
        let buttons = {}
        buttons.accent = this.colorFactory.isBlackOrWhite(color) ? this.generateBlackButton() : this.generateSameColorButton(color, 'accent')
        return buttons
    }

    generateDarkSameColorButtons(color) {
        let buttons = {}
        buttons.primary = this.colorFactory.isBlackOrWhite(color) ? this.generateWhiteButton() : this.generateContrastingButtons(color)
        buttons.secondary = this.defaultSecondaryButton()
        return buttons
    }

    generateWhiteButton() {
        let textColor = this.colorFactory.createColorObject('slate', '900')
        let bgColor = this.colorFactory.createColorObject('white')
        let hoverBgColor = this.colorFactory.createColorObject('slate', '100')

        return {
            name: 'primary',
            // color: textColor,
            // bgColor: bgColor,
            // hoverBgColor: hoverBgColor,
            borderColor: this.colorFactory.createColorObject('slate', '200'),
            hoverBorderColor: this.colorFactory.createColorObject('slate', '200'),
            hoverEffect: 'none',
            background: this.backgroundFactory.createBackground2(bgColor, textColor, 'button'),
            hoverBackground: this.backgroundFactory.createBackground2(hoverBgColor, textColor, 'buttonHover'),
        }
    }

    generateBlackButton() {
        let textColor = this.colorFactory.createColorObject('white')
        let bgColor = this.colorFactory.createColorObject('slate', '900')
        let hoverBgColor = this.colorFactory.createColorObject('slate', '800')
        return {
            name: 'primary',
            // color: textColor,
            // bgColor: bgColor,
            // hoverBgColor: hoverBgColor,
            borderColor: this.colorFactory.createColorObject('slate', '900'),
            hoverBorderColor: this.colorFactory.createColorObject('slate', '800'),
            hoverEffect: 'none',
            background: this.backgroundFactory.createBackground2(bgColor, textColor, 'button'),
            hoverBackground: this.backgroundFactory.createBackground2(hoverBgColor, textColor, 'buttonHover'),
        }
    }

    generateSameColorButton(color, name='primary') {
        let shade = Number(color.shade)

        // this is generally the background color we are contrasting with
        if (shade > 500) {
            let textColor = this.colorFactory.createColorObject(color.name, '100')
            let bgColor = this.colorFactory.createColorObject(color.name, color.shade)
            let hoverBgColor = this.colorFactory.createColorObject(color.name, (shade - 100).toString())

            return {
                name: name,
                // color: textColor,
                // bgColor: bgColor,
                // hoverBgColor: hoverBgColor,
                borderColor: this.colorFactory.createColorObject(color.name, '300'),
                hoverBorderColor: this.colorFactory.createColorObject(color.name, '300'),
                hoverEffect: 'none',
                background: this.backgroundFactory.createBackground2(bgColor, textColor, 'button'),
                hoverBackground: this.backgroundFactory.createBackground2(hoverBgColor, textColor, 'buttonHover'),
            }
        } else {
            let darkerShade = shade === 50 ? 500 : shade + 300
            let textColor = this.colorFactory.createColorObject(color.name, darkerShade.toString())
            let bgColor = this.colorFactory.createColorObject(color.name, color.shade)
            let hoverBgColor = this.colorFactory.createColorObject(color.name, (shade + 100).toString())

            return {
                name: name,
                // color: textColor,
                // bgColor: bgColor,
                // hoverBgColor: hoverBgColor,
                borderColor: this.colorFactory.createColorObject(color.name, darkerShade.toString()),
                hoverBorderColor: this.colorFactory.createColorObject(color.name, (darkerShade + 100).toString()),
                hoverEffect: 'none',
                background: this.backgroundFactory.createBackground2(bgColor, textColor, 'button'),
                hoverBackground: this.backgroundFactory.createBackground2(hoverBgColor, textColor, 'buttonHover'),
            }
        }

    }

    generateContrastingButtons(color) {
        let shade = Number(color.shade)

        // this is generally the background color we are contrasting with
        if (shade > 500) {
            let textColor = this.colorFactory.createColorObject(color.name, color.shade)
            let bgColor = this.colorFactory.createColorObject(color.name, '100')
            let hoverBgColor = this.colorFactory.createColorObject(color.name, '200')

            return {
                name: 'primary',
                // color: textColor,
                // bgColor: bgColor,
                // hoverBgColor: hoverBgColor,
                borderColor: this.colorFactory.createColorObject(color.name, '300'),
                hoverBorderColor: this.colorFactory.createColorObject(color.name, '300'),
                hoverEffect: 'none',
                background: this.backgroundFactory.createBackground2(bgColor, textColor, 'button'),
                hoverBackground: this.backgroundFactory.createBackground2(hoverBgColor, textColor, 'buttonHover'),
            }
        } else {
            let darkerShade = shade === 50 ? 500 : shade + 300
            let textColor = this.colorFactory.createColorObject(color.name, '100')
            let bgColor = this.colorFactory.createColorObject(color.name, darkerShade.toString())
            let hoverBgColor = this.colorFactory.createColorObject(color.name, (darkerShade + 100).toString())

            return {
                name: 'primary',
                // color: textColor,
                // bgColor: bgColor,
                // hoverBgColor: hoverBgColor,
                borderColor: this.colorFactory.createColorObject(color.name, darkerShade.toString()),
                hoverBorderColor: this.colorFactory.createColorObject(color.name, (darkerShade + 100).toString()),
                hoverEffect: 'none',
                background: this.backgroundFactory.createBackground2(bgColor, textColor, 'button'),
                hoverBackground: this.backgroundFactory.createBackground2(hoverBgColor, textColor, 'buttonHover'),
            }
        }

    }

    defaultSecondaryButton() {
        let textColor = this.colorFactory.createColorObject('slate', '800')
        let bgColor = this.colorFactory.createColorObject('slate', '50')
        let hoverBgColor = this.colorFactory.createColorObject('slate', '100')

        return {
            name: 'secondary',
            // color: textColor,
            // bgColor: bgColor,
            // hoverBgColor: hoverBgColor,
            borderColor: this.colorFactory.createColorObject('slate', '200'),
            hoverBorderColor: this.colorFactory.createColorObject('slate', '200'),
            hoverEffect: 'none',
            background: this.backgroundFactory.createBackground2(bgColor, textColor, 'button'),
            hoverBackground: this.backgroundFactory.createBackground2(hoverBgColor, textColor, 'buttonHover'),
        }
    }

    smallCssClasses(button, buttonStyle = 'rounded') {
        let classes = ['py-1', 'px-4', 'border']

        if (buttonStyle === 'rounded') {
            classes.push('rounded-lg')
        } else if (buttonStyle === 'pill') {
            classes.push('rounded-full')
        }

        return this.addColorClasses(classes, button)
    }

    cssClasses(button, buttonStyle = 'rounded') {
        // let classes = ['border']
        let classes = []  // TODO need to conditionally add border class

        if (buttonStyle === 'rounded') {
            classes.push('rounded-lg')
        } else if (buttonStyle === 'pill') {
            classes.push('rounded-full')
        }

        return this.addColorClasses(classes, button)
    }

    addColorClasses(classes, button) {
        if(button.background === undefined) {
            // console.log('******************************************')
            // console.log('Using old button BG system!')
            // console.log('******************************************')
            const styleUtil = webase.utils.styleManager.getStyleUtil()
            classes.push(styleUtil.toColorClass(button.bgColor, 'bg'))
            classes.push(styleUtil.toColorClass(button.color, 'text'))
            // console.log(button.borderColor)
            classes.push(styleUtil.toColorClass(button.borderColor, 'border'))
            classes.push(styleUtil.toColorClass(button.hoverBgColor, 'hover:bg'))
            classes.push(styleUtil.toColorClass(button.hoverBorderColor, 'hover:border'))
            return classes
        }

        // console.log('------------------------------------------')
        // console.log('Using new button BG system!')
        // console.log('------------------------------------------')
        let bgClasses = this.backgroundFactory.cssClasses(button.background)
        let hoverBgClasses = this.backgroundFactory.cssClasses(button.hoverBackground, 'hover:')
        const styleUtil = webase.utils.styleManager.getStyleUtil()
        // console.log(button.borderColor)

        if(button.borderColor) {
            classes.push(styleUtil.toColorClass(button.borderColor, 'border'))
        }

        if(button.hoverBorderColor) {
            classes.push(styleUtil.toColorClass(button.hoverBorderColor, 'hover:border'))
        }

        if(button.boxShadow && button.boxShadow !== 'none') {
            let shadowClass = button.boxShadow === 'DEFAULT' ? 'shadow' : `shadow-${button.boxShadow}`
            classes.push(shadowClass)
        }

        return classes.concat(bgClasses).concat(hoverBgClasses)
    }
}